import gql from 'graphql-tag';

export const HISTORICAL_PRICE_QUERY = gql`
    query HistoricalPricesChart($ticker: String!) {
        mutualFund(ticker: $ticker) {
            name: shortName
            ticker
            priceHistory {
                price
                asOfDate
            }
        }
    }
`;
